var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'AutoMarketingMemberEvent'
      }
    }
  }, [_vm._v("會員事件設定")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.title) + " ")])], 1)], 1)])]), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row align-items-stretch"
  }, [_c('div', {
    staticClass: "mail-sidebar d-none d-lg-block col-md-2 pt-3 bg-white"
  }, [_c('div', {
    staticClass: "menu-bar"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, [_c('li', {
    class: _vm.step == '' ? 'active' : '',
    on: {
      "click": function click($event) {
        return _vm.goToStep('');
      }
    }
  }, [_c('a', [_vm._v("基本設定")]), _c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('li', {
    class: _vm.step == '#trigger' ? 'active' : '',
    on: {
      "click": function click($event) {
        return _vm.goToStep('#trigger');
      }
    }
  }, [_c('a', [_vm._v("觸發條件")]), _c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('li', {
    class: _vm.step == '#event' ? 'active' : '',
    on: {
      "click": function click($event) {
        return _vm.goToStep('#event');
      }
    }
  }, [_c('a', [_vm._v("執行事件內容")]), _c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _c('div', {
    staticClass: "mail-view d-none d-md-block col-md-9 col-lg-10 bg-white"
  }, [_c('b-card', [_vm.step == '' ? _c('section', {
    staticClass: "mb-5"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v("基本設定")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "通路",
      "label-for": "merchant"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.isFetchMerchants || _vm.isReadOnly
    },
    model: {
      value: _vm.form.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "merchant_id", $$v);
      },
      expression: "form.merchant_id"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.merchant_id.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "標題"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.form.title.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.title.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "使用期間"
    }
  }, [_c('div', {
    staticClass: "\n                  d-flex\n                  flex-column flex-xl-row\n                  align-items-start align-items-xl-center\n                "
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isReadOnly,
      "disabledDates": _vm.disabledDates,
      "clear-button": "",
      "input-class": _vm.v$.form.start_at.$error ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.start_at,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "start_at", $$v);
      },
      expression: "form.start_at"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isReadOnly,
      "disabledDates": _vm.disabledDates,
      "clear-button": "",
      "input-class": _vm.v$.form.end_at.$error ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.end_at,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "end_at", $$v);
      },
      expression: "form.end_at"
    }
  })], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否啟用"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.form.is_enabled.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_enabled", $$v);
      },
      expression: "form.is_enabled"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.is_enabled.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goListPage
    }
  }, [_vm._v("返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1)], 1) : _vm._e(), _vm.step == '#trigger' ? _c('section', {
    staticClass: "mb-5"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v("觸發條件")]), _vm.form.trigger.type ? _c('div', {
    staticClass: "flex-fill"
  }, [_vm.form.trigger.type == 'birthday' ? [_c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "day"
    },
    on: {
      "change": function change() {
        _vm.form.trigger = {
          type: _vm.form.trigger.type,
          value: 'day'
        };
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _vm._v(" 每天 ")], 1), _c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "week"
    },
    on: {
      "change": function change() {
        _vm.form.trigger = {
          type: _vm.form.trigger.type,
          value: 'week'
        };
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _vm._v(" 每週 ")], 1), _c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "month"
    },
    on: {
      "change": function change() {
        _vm.form.trigger = {
          type: _vm.form.trigger.type,
          value: 'month'
        };
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _vm._v(" 每月 ")], 1)] : _vm.form.trigger.type == 'line_follow' ? [_c('div', [_vm._v("加入好友立即觸發")])] : _vm.form.trigger.type == 'registered' ? [_c('div', [_vm._v("註冊後立即觸發")])] : _vm._e(), _vm.form.trigger.type == 'customer_upgraded' ? [_c('div', {
    staticClass: "mb-3"
  }, [_vm._v("升等時立即觸發")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "來源等級"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.fromLevelOptions,
      "disabled": _vm.isReadOnly || _vm.isFetchCustomerLevels
    },
    model: {
      value: _vm.levelCondition.from_customer_level_id,
      callback: function callback($$v) {
        _vm.$set(_vm.levelCondition, "from_customer_level_id", $$v);
      },
      expression: "levelCondition.from_customer_level_id"
    }
  }), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" 選擇性設定：指定從哪個等級升等而來，不選擇則代表任何等級升等都觸發 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "目標等級"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.toLevelOptions,
      "disabled": _vm.isReadOnly || _vm.isFetchCustomerLevels
    },
    model: {
      value: _vm.levelCondition.to_customer_level_id,
      callback: function callback($$v) {
        _vm.$set(_vm.levelCondition, "to_customer_level_id", $$v);
      },
      expression: "levelCondition.to_customer_level_id"
    }
  }), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" 選擇性設定：指定升等到哪個等級時觸發，不選擇則代表升等到任何等級都觸發 ")])], 1)] : _vm._e(), _vm.form.trigger.type == 'customer_extended' ? [_c('div', {
    staticClass: "mb-3"
  }, [_vm._v("續等時立即觸發")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "續等等級"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.extendLevelOptions,
      "disabled": _vm.isReadOnly || _vm.isFetchCustomerLevels
    },
    model: {
      value: _vm.levelCondition.customer_level_id,
      callback: function callback($$v) {
        _vm.$set(_vm.levelCondition, "customer_level_id", $$v);
      },
      expression: "levelCondition.customer_level_id"
    }
  }), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" 選擇性設定：指定續等哪個等級時觸發，不選擇則代表任何等級續等都觸發 ")])], 1)] : _vm._e(), _vm.form.trigger.type == 'customer_downgraded' ? [_c('div', {
    staticClass: "mb-3"
  }, [_vm._v("降等時立即觸發")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "來源等級"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.fromLevelOptions,
      "disabled": _vm.isReadOnly || _vm.isFetchCustomerLevels
    },
    model: {
      value: _vm.levelCondition.from_customer_level_id,
      callback: function callback($$v) {
        _vm.$set(_vm.levelCondition, "from_customer_level_id", $$v);
      },
      expression: "levelCondition.from_customer_level_id"
    }
  }), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" 選擇性設定：指定從哪個等級降等而來，不選擇則代表任何等級降等都觸發 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "目標等級"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.toLevelOptions,
      "disabled": _vm.isReadOnly || _vm.isFetchCustomerLevels
    },
    model: {
      value: _vm.levelCondition.to_customer_level_id,
      callback: function callback($$v) {
        _vm.$set(_vm.levelCondition, "to_customer_level_id", $$v);
      },
      expression: "levelCondition.to_customer_level_id"
    }
  }), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" 選擇性設定：指定降等到哪個等級時觸發，選擇「無等級」代表降等到沒有會員等級 ")])], 1)] : _vm.form.trigger.type == 'checkin' ? [_c('div', {
    staticClass: "form-inline mb-2"
  }, [_vm._v(" 連續 "), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "min": "1",
      "state": _vm.v$.form.trigger['continuous'] && _vm.v$.form.trigger['continuous'].$error ? false : null
    },
    model: {
      value: _vm.form.trigger['continuous'],
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, 'continuous', _vm._n($$v));
      },
      expression: "form.trigger['continuous']"
    }
  }), _vm._v(" 天 ")], 1)] : _vm.form.trigger.type == 'login' ? [_c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "min": "1",
      "state": _vm.v$.form.trigger['frequency'] && _vm.v$.form.trigger['frequency'].$error ? false : null
    },
    model: {
      value: _vm.form.trigger['frequency'],
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, 'frequency', _vm._n($$v));
      },
      expression: "form.trigger['frequency']"
    }
  }), _vm._v(" 次 ")], 1)] : _vm.form.trigger.type == 'special-login' ? [_c('div', {
    staticClass: "form-inline mb-2 d-flex flex-nowrap"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "dateRange"
    },
    on: {
      "change": function change() {
        _vm.form.trigger = {
          type: _vm.form.trigger.type,
          value: 'dateRange',
          dateRange: {
            from: new Date(),
            to: new Date()
          },
          timeRange: {
            from: {
              HH: null,
              mm: null
            },
            to: {
              HH: null,
              mm: null
            }
          }
        };
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _c('div', [_c('div', {
    staticClass: "\n                        d-flex\n                        flex-column flex-xl-row\n                        align-items-start align-items-xl-center\n                      "
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "clear-button": "",
      "disabled": _vm.form.trigger.value != 'dateRange',
      "disabledDates": _vm.disabledDates,
      "input-class": _vm.v$.form.trigger['dateRange'].from && _vm.v$.form.trigger['dateRange'].from.$error ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.trigger.dateRange.from,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger.dateRange, "from", $$v);
      },
      expression: "form.trigger.dateRange.from"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "clear-button": "",
      "disabled": _vm.form.trigger.value != 'dateRange',
      "disabledDates": _vm.disabledDates,
      "input-class": _vm.v$.form.trigger['dateRange'].to && _vm.v$.form.trigger['dateRange'].to.$error ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.trigger.dateRange.to,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger.dateRange, "to", $$v);
      },
      expression: "form.trigger.dateRange.to"
    }
  })], 1), _c('b-form-invalid-feedback', {
    staticClass: "w-100",
    attrs: {
      "state": _vm.v$.form.trigger['dateRange'].beforeEndAt && !_vm.v$.form.trigger.dateRange.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1)], 1), _c('div', {
    staticClass: "form-inline mb-2 d-flex flex-nowrap"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "timeRange"
    },
    on: {
      "change": function change() {
        _vm.form.trigger = {
          type: _vm.form.trigger.type,
          value: 'timeRange',
          dateRange: {
            from: new Date(),
            to: new Date()
          },
          timeRange: {
            from: {
              HH: null,
              mm: null
            },
            to: {
              HH: null,
              mm: null
            }
          }
        };
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _c('div', [_c('div', {
    staticClass: "\n                        d-flex\n                        flex-column flex-xl-row\n                        align-items-start align-items-xl-center\n                      "
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "disabled": _vm.form.trigger.value != 'timeRange',
      "input-class": ['form-control', _vm.v$.form.trigger['timeRange'].from && (_vm.v$.form.trigger['timeRange'].from.HH.$error || _vm.v$.form.trigger['timeRange'].from.mm.$error) ? 'is-invalid' : '']
    },
    model: {
      value: _vm.form.trigger.timeRange.from,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger.timeRange, "from", $$v);
      },
      expression: "form.trigger.timeRange.from"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "disabled": _vm.form.trigger.value != 'timeRange',
      "input-class": ['form-control', _vm.v$.form.trigger['timeRange'].to && (_vm.v$.form.trigger['timeRange'].to.HH.$error || _vm.v$.form.trigger['timeRange'].to.mm.$error) ? 'is-invalid' : '']
    },
    model: {
      value: _vm.form.trigger.timeRange.to,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger.timeRange, "to", $$v);
      },
      expression: "form.trigger.timeRange.to"
    }
  })], 1), _c('b-form-invalid-feedback', {
    staticClass: "w-100",
    attrs: {
      "state": _vm.v$.form.trigger.timeRange.beforeEndAt && !_vm.v$.form.trigger.timeRange.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1)], 1)] : _vm._e(), ['purchase', 'month-purchase', 'range-purchase'].includes(_vm.form.trigger.type) ? [_c('div', {
    staticClass: "form-inline mb-2"
  }, [_vm.form.trigger.type == 'range-purchase' ? _c('div', {
    staticClass: "\n                      d-flex\n                      flex-column flex-xl-row\n                      align-items-start align-items-xl-center\n                    "
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "clear-button": "",
      "disabledDates": _vm.disabledDates,
      "input-class": _vm.v$.form.trigger.from && _vm.v$.form.trigger.from.$error ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.trigger.from,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "from", $$v);
      },
      expression: "form.trigger.from"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "clear-button": "",
      "disabledDates": _vm.disabledDates,
      "input-class": _vm.v$.form.trigger.to && _vm.v$.form.trigger.to.$error ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.trigger.to,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "to", $$v);
      },
      expression: "form.trigger.to"
    }
  })], 1) : _vm._e(), _c('b-form-invalid-feedback', {
    staticClass: "w-100",
    attrs: {
      "state": _vm.v$.form.trigger.from.beforeEndAt && !_vm.v$.form.trigger.from.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1), _c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "frequency"
    },
    on: {
      "change": function change() {
        var v = {
          type: _vm.form.trigger.type,
          value: 'frequency',
          frequency: 1
        };
        if (v.type == 'range-purchase') {
          v.from = _vm.form.trigger.from;
          v.to = _vm.form.trigger.to;
        }
        _vm.form.trigger = v;
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "disabled": _vm.form.trigger.value != 'frequency',
      "min": "1",
      "state": _vm.v$.form.trigger.frequency && _vm.v$.form.trigger.frequency.$error ? false : null
    },
    model: {
      value: _vm.form.trigger['frequency'],
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, 'frequency', _vm._n($$v));
      },
      expression: "form.trigger['frequency']"
    }
  }), _vm._v(" 次 ")], 1), _c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "item"
    },
    on: {
      "change": function change() {
        var v = {
          type: _vm.form.trigger.type,
          value: 'item',
          item: 1
        };
        if (v.type == 'range-purchase') {
          v.from = _vm.form.trigger.from;
          v.to = _vm.form.trigger.to;
        }
        _vm.form.trigger = v;
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "disabled": _vm.form.trigger.value != 'item',
      "min": "1",
      "state": _vm.v$.form.trigger.item && _vm.v$.form.trigger.item.$error ? false : null
    },
    model: {
      value: _vm.form.trigger['item'],
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, 'item', _vm._n($$v));
      },
      expression: "form.trigger['item']"
    }
  }), _vm._v(" 項商品 ")], 1), _c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "amount"
    },
    on: {
      "change": function change() {
        var v = {
          type: _vm.form.trigger.type,
          value: 'amount',
          amount: 1
        };
        if (v.type == 'range-purchase') {
          v.from = _vm.form.trigger.from;
          v.to = _vm.form.trigger.to;
        }
        _vm.form.trigger = v;
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _vm._v(" 滿 "), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "disabled": _vm.form.trigger.value != 'amount',
      "min": "1",
      "state": _vm.v$.form.trigger.amount && _vm.v$.form.trigger.amount.$error ? false : null
    },
    model: {
      value: _vm.form.trigger['amount'],
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, 'amount', _vm._n($$v));
      },
      expression: "form.trigger['amount']"
    }
  }), _vm._v(" 金額 ")], 1)] : _vm._e(), _vm.form.trigger.type === 'birthday' ? [_c('hr', {
    staticClass: "my-4"
  }), _c('h5', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v("額外篩選條件")]), _c('b-form-group', [_c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.isReadOnly || _vm.isFetchCustomerLevels
    },
    model: {
      value: _vm.enableLevelMatch,
      callback: function callback($$v) {
        _vm.enableLevelMatch = $$v;
      },
      expression: "enableLevelMatch"
    }
  }, [_vm._v(" 是否判斷會員等級 ")]), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" 勾選後，只有符合指定等級的會員才會觸發此事件 ")])], 1), _vm.enableLevelMatch ? _c('div', {
    staticClass: "ml-4 mt-3"
  }, [_vm.isFetchCustomerLevels ? _c('div', {
    staticClass: "text-muted"
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" 載入會員等級中... ")], 1) : _vm.customerLevelOptions.length === 0 ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" 尚未設定會員等級 ")]) : _c('div', [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v("請選擇符合條件的會員等級：")]), _c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.customerLevelOptions.map(function (level) {
        return {
          value: level.hashid,
          text: level.text
        };
      }),
      "stacked": "",
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.selectedLevelHashIds,
      callback: function callback($$v) {
        _vm.selectedLevelHashIds = $$v;
      },
      expression: "selectedLevelHashIds"
    }
  })], 1)]) : _vm._e()] : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goListPage
    }
  }, [_vm._v("返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1)], 2) : _vm._e()]) : _vm._e(), _vm.step == '#event' ? _c('section', {
    staticClass: "mb-5"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v("執行事件內容")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "貼標"
    }
  }, [_c('div', {
    staticClass: "border rounded p-1"
  }, [_vm._l(_vm.form.response.tags, function (tag, idx) {
    return _c('b-badge', {
      key: idx,
      staticClass: "m-1",
      attrs: {
        "variant": "dark"
      }
    }, [_vm._v(" " + _vm._s(tag) + " "), _c('button', {
      staticClass: "btn btn-xs p-0",
      on: {
        "click": function click($event) {
          return _vm.form.response.tags.splice(idx, 1);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove text-white"
    })])]);
  }), _c('b-input', {
    staticClass: "border-0",
    attrs: {
      "type": "text",
      "maxlength": "40",
      "placeholder": "輸入標籤"
    },
    on: {
      "keyup": function keyup(e) {
        var v = null;
        if (e.key == ',') {
          v = e.target.value.slice(0, -1);
        } else if (e.key == 'Enter') {
          v = e.target.value;
        }
        if (v && !_vm.form.response.tags.includes(v)) {
          _vm.form.response.tags.push(v);
          e.target.value = '';
        }
      }
    }
  })], 2)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "發放優惠卷"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-search-coupon",
      modifiers: {
        "modal-search-coupon": true
      }
    }],
    staticClass: "ml-0 btn-inverse-primary",
    attrs: {
      "disabled": _vm.showLoading || _vm.isFetchCoupon
    }
  }, [_vm._v(" 選擇優惠券 ")]), _vm.showLoading || _vm.isFetchCoupon ? _c('div', {
    staticClass: "ml-2"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _vm._e()], 1), _c('div', _vm._l(_vm.selectedCoupons, function (coupon, idx) {
    return _c('b-card', {
      key: coupon.id,
      staticClass: "mb-3",
      attrs: {
        "no-body": ""
      }
    }, [_c('b-card-header', {
      staticClass: "d-flex justify-content-between align-items-center py-2"
    }, [_c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(coupon.name))]), _c('b-button', {
      staticClass: "text-danger p-0",
      attrs: {
        "variant": "link"
      },
      on: {
        "click": function click($event) {
          return _vm.handleUpdateCoupon(coupon);
        }
      }
    }, [_c('i', {
      staticClass: "mdi mdi-close mdi-18px"
    })])], 1), _c('b-card-body', {
      staticClass: "py-2"
    }, [_c('b-form-checkbox', {
      staticClass: "mb-2",
      attrs: {
        "disabled": _vm.isReadOnly
      },
      model: {
        value: _vm.selectedCoupons[idx].is_push_line,
        callback: function callback($$v) {
          _vm.$set(_vm.selectedCoupons[idx], "is_push_line", $$v);
        },
        expression: "selectedCoupons[idx].is_push_line"
      }
    }, [_vm._v(" 推播 LINE 通知 ")]), _c('b-form-checkbox', {
      attrs: {
        "disabled": _vm.isReadOnly
      },
      model: {
        value: _vm.selectedCoupons[idx].repeat_assign,
        callback: function callback($$v) {
          _vm.$set(_vm.selectedCoupons[idx], "repeat_assign", $$v);
        },
        expression: "selectedCoupons[idx].repeat_assign"
      }
    }, [_vm._v(" 允許重複發放 ")])], 1)], 1);
  }), 1)]), _c('AutoMarketingSearchCoupon', {
    attrs: {
      "selectedCoupons": _vm.selectedCoupons
    },
    on: {
      "submit": _vm.handleSubmitCoupon
    }
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "發放徽章"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2",
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.form.response.badge.id,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.badge, "id", $$v);
      },
      expression: "form.response.badge.id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "發放點數"
    }
  }, [!_vm.isEnablePoint ? _c('div', {
    key: "point-disabled-view"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        _vm.isEnablePoint = true;
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-plus mr-1"
  }), _vm._v("新增點數發放 ")])], 1) : _vm._e(), _vm.isEnablePoint ? _c('b-card', {
    key: "point-enabled-view",
    staticClass: "mb-3 border-secondary shadow-sm",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "d-flex justify-content-between align-items-center py-2 bg-light"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("點數發放設定")]), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "text-danger p-0",
    attrs: {
      "variant": "link",
      "title": "取消點數發放"
    },
    on: {
      "click": _vm.handleDisablePoint
    }
  }, [_c('i', {
    staticClass: "mdi mdi-close-circle mdi-24px"
  })])], 1), _c('b-card-body', {
    staticClass: "p-4"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-3"
  }, [_c('h6', {
    staticClass: "mb-0 font-weight-bold"
  }, [_vm._v("點數發放名稱")])]), _c('div', {
    staticClass: "pl-4 mb-4"
  }, [_c('b-form-input', {
    attrs: {
      "id": "point-name-input",
      "type": "text",
      "placeholder": "請輸入點數發放名稱",
      "size": "sm",
      "disabled": _vm.isReadOnly,
      "maxlength": "100"
    },
    model: {
      value: _vm.form.response.point.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point, "name", $$v);
      },
      expression: "form.response.point.name"
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-items-center mb-3"
  }, [_c('h6', {
    staticClass: "mb-0 font-weight-bold"
  }, [_vm._v("發放方式與數值")])]), _c('div', {
    staticClass: "pl-4"
  }, [_c('div', {
    staticClass: "bg-white rounded border overflow-hidden"
  }, [_c('div', {
    staticClass: "d-flex align-items-center p-3 border-bottom"
  }, [_c('b-form-radio', {
    staticClass: "m-0 mr-2",
    attrs: {
      "value": "fixed"
    },
    model: {
      value: _vm.form.response.point.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point, "type", $$v);
      },
      expression: "form.response.point.type"
    }
  }), _c('span', {
    staticClass: "mr-3"
  }, [_vm._v("固定發放")]), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "size": "sm",
      "min": "1"
    },
    model: {
      value: _vm.form.response.point.point,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point, "point", _vm._n($$v));
      },
      expression: "form.response.point.point"
    }
  }), _c('span', [_vm._v("點")])], 1), _c('div', {
    staticClass: "px-3 py-2 bg-light"
  }, [_c('b-form-checkbox', {
    staticClass: "m-0",
    attrs: {
      "size": "sm"
    },
    model: {
      value: _vm.form.response.point.allow_repeat,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point, "allow_repeat", $$v);
      },
      expression: "form.response.point.allow_repeat"
    }
  }, [_c('span', {
    staticClass: "text-dark"
  }, [_vm._v("允許重複發送")])]), _c('div', {
    staticClass: "text-muted mt-1 ml-4",
    staticStyle: {
      "font-size": "0.8rem"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-information-outline"
  }), _vm._v(" 勾選後，符合條件時可重複領取（例如：每年生日皆能再次獲取點數）。 ")])], 1)])])]), _c('hr', {
    staticClass: "my-4 border-light"
  }), _c('div', [_c('div', {
    staticClass: "d-flex align-items-center mb-3"
  }, [_c('h6', {
    staticClass: "mb-0 font-weight-bold"
  }, [_vm._v("點數過期規則")])]), _c('div', {
    staticClass: "pl-4"
  }, [_c('div', {
    staticClass: "mb-3 p-3 rounded border",
    class: _vm.form.response.point.expiration.type === 'none' ? 'border-primary bg-white' : 'bg-light'
  }, [_c('b-form-radio', {
    attrs: {
      "value": "none"
    },
    model: {
      value: _vm.form.response.point.expiration.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point.expiration, "type", $$v);
      },
      expression: "form.response.point.expiration.type"
    }
  }, [_c('span', {
    class: _vm.form.response.point.expiration.type === 'none' ? 'font-weight-bold text-primary' : ''
  }, [_vm._v("永久有效 (無期限)")])])], 1), _c('div', {
    staticClass: "mb-3 p-3 rounded border",
    class: _vm.form.response.point.expiration.type === 'shifted_date' ? 'border-primary bg-white' : 'bg-light'
  }, [_c('b-form-radio', {
    staticClass: "mb-2",
    attrs: {
      "value": "shifted_date"
    },
    model: {
      value: _vm.form.response.point.expiration.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point.expiration, "type", $$v);
      },
      expression: "form.response.point.expiration.type"
    }
  }, [_c('span', {
    class: _vm.form.response.point.expiration.type === 'shifted_date' ? 'font-weight-bold text-primary' : ''
  }, [_vm._v("依相對時間過期")])]), _vm.form.response.point.expiration.type === 'shifted_date' ? _c('div', {
    staticClass: "d-flex align-items-center ml-4"
  }, [_c('span', {
    staticClass: "mr-2"
  }, [_vm._v("發放後")]), _c('b-form-input', {
    staticClass: "mx-1",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "number",
      "size": "sm"
    },
    model: {
      value: _vm.form.response.point.expiration.number,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point.expiration, "number", _vm._n($$v));
      },
      expression: "\n                              form.response.point.expiration.number\n                            "
    }
  }), _c('b-form-select', {
    staticClass: "mx-1",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "options": _vm.expirationUnitOptions,
      "size": "sm"
    },
    model: {
      value: _vm.form.response.point.expiration.unit,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point.expiration, "unit", $$v);
      },
      expression: "form.response.point.expiration.unit"
    }
  }), _c('span', [_vm._v("自動失效")])], 1) : _vm._e()], 1), _c('div', {
    staticClass: "mb-3 p-3 rounded border",
    class: _vm.form.response.point.expiration.type === 'fixed_date' ? 'border-primary bg-white' : 'bg-light'
  }, [_c('b-form-radio', {
    staticClass: "mb-2",
    attrs: {
      "value": "fixed_date"
    },
    model: {
      value: _vm.form.response.point.expiration.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point.expiration, "type", $$v);
      },
      expression: "form.response.point.expiration.type"
    }
  }, [_c('span', {
    class: _vm.form.response.point.expiration.type === 'fixed_date' ? 'font-weight-bold text-primary' : ''
  }, [_vm._v("依特定日期過期 (年度週期)")]), _c('i', {
    staticClass: "fa fa-question-circle ml-1 text-muted",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "點擊，觀看設定說明"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        _vm.showFixedDateModal = true;
      }
    }
  })]), _vm.form.response.point.expiration.type === 'fixed_date' ? _c('div', {
    staticClass: "ml-4"
  }, [_c('div', {
    staticClass: "\n                              d-flex\n                              align-items-center\n                              mb-3\n                              p-2\n                              bg-light\n                              rounded-sm\n                              border\n                            "
  }, [_c('i', {
    staticClass: "mdi mdi-calendar-range mr-2 text-primary"
  }), _c('span', {
    staticClass: "mr-1"
  }, [_vm._v("年度週期：")]), _c('b-form-select', {
    staticClass: "mx-1 w-auto",
    attrs: {
      "options": _vm.monthOptions,
      "size": "sm"
    },
    model: {
      value: _vm.form.response.point.expiration.period_start_month,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point.expiration, "period_start_month", $$v);
      },
      expression: "\n                                form.response.point.expiration\n                                  .period_start_month\n                              "
    }
  }), _vm._v(" 月 "), _c('b-form-select', {
    staticClass: "mx-1 w-auto",
    attrs: {
      "options": _vm.dayOptions(_vm.form.response.point.expiration.period_start_month),
      "size": "sm"
    },
    model: {
      value: _vm.form.response.point.expiration.period_start_day,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point.expiration, "period_start_day", $$v);
      },
      expression: "\n                                form.response.point.expiration\n                                  .period_start_day\n                              "
    }
  }), _vm._v(" 日 "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("至")]), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v(_vm._s(_vm.form.response.point.expiration.period_end_month) + " 月 " + _vm._s(_vm.form.response.point.expiration.period_end_day) + " 日")])], 1), _c('div', {
    staticClass: "d-flex align-items-center flex-wrap mt-2",
    staticStyle: {
      "line-height": "2"
    }
  }, [_c('span', [_vm._v("點數將於")]), _c('span', {
    staticClass: "mx-1 text-primary"
  }, [_vm._v(_vm._s(_vm.form.response.point.expiration.period_end_month) + " 月 " + _vm._s(_vm.form.response.point.expiration.period_end_day) + " 日")]), _c('span', [_vm._v("結算，並在")]), _c('b-form-input', {
    staticClass: "mx-1 text-center",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "type": "number",
      "size": "sm"
    },
    model: {
      value: _vm.form.response.point.expiration.expiry_offset_years,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point.expiration, "expiry_offset_years", _vm._n($$v));
      },
      expression: "\n                                form.response.point.expiration\n                                  .expiry_offset_years\n                              "
    }
  }), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v("年後的")]), _c('b-form-select', {
    staticClass: "mx-1",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "options": _vm.expiryMonthOptions,
      "size": "sm"
    },
    model: {
      value: _vm.form.response.point.expiration.expiry_month,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point.expiration, "expiry_month", $$v);
      },
      expression: "\n                                form.response.point.expiration.expiry_month\n                              "
    }
  }), _vm._v(" 月 "), _c('b-form-select', {
    staticClass: "mx-1",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "options": _vm.expiryDayOptions,
      "size": "sm"
    },
    model: {
      value: _vm.form.response.point.expiration.expiry_day,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point.expiration, "expiry_day", $$v);
      },
      expression: "\n                                form.response.point.expiration.expiry_day\n                              "
    }
  }), _vm._v(" 日 "), _c('span', {
    staticClass: "ml-1 text-danger"
  }, [_vm._v("正式失效")])], 1), _vm.fixedDatePreview ? _c('div', {
    staticClass: "mt-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "0.875rem",
      "color": "#28a745"
    },
    on: {
      "click": function click($event) {
        _vm.showFixedDatePreview = !_vm.showFixedDatePreview;
      }
    }
  }, [_c('i', {
    staticClass: "mr-1",
    class: _vm.showFixedDatePreview ? 'fa fa-chevron-down' : 'fa fa-chevron-right'
  }), _vm._v(" 預覽試算 ")]), _vm.showFixedDatePreview ? _c('div', {
    staticClass: "mt-1 p-2 rounded border border-success",
    staticStyle: {
      "font-size": "0.875rem",
      "color": "#28a745",
      "background-color": "#f0fff4"
    }
  }, [_vm._v(" 若您在 今日: "), _c('strong', [_vm._v(_vm._s(_vm.fixedDatePreview.todayStr))]), _vm._v(" 發放點數，"), _c('br'), _vm._v(" 該點數將歸屬於 "), _c('strong', [_vm._v(_vm._s(_vm.fixedDatePreview.cycleStartStr) + " ~ " + _vm._s(_vm.fixedDatePreview.cycleEndStr))]), _vm._v(" 週期，並於 "), _c('strong', [_vm._v(_vm._s(_vm.fixedDatePreview.expiryStr))]), _vm._v(" 到期。 ")]) : _vm._e()]) : _vm._e()]) : _vm._e()], 1), _c('b-modal', {
    attrs: {
      "title": "點數(依特定日期) 說明",
      "ok-only": "",
      "ok-title": "關閉",
      "dialog-class": "modal-half"
    },
    model: {
      value: _vm.showFixedDateModal,
      callback: function callback($$v) {
        _vm.showFixedDateModal = $$v;
      },
      expression: "showFixedDateModal"
    }
  }, [_c('p', [_vm._v("系統將依據您設定的「年度週期」歸納點數，同一週期內獲得的點數，將統一於指定的延長年份日期失效。")]), _c('p', [_c('strong', [_vm._v("舉例情境：")]), _vm._v("若設定週期為 1/10 至 隔年1/9，並於 1 年後的 12/31 失效。若會員在 2026/01/30 獲得點數（屬於2026/01/10 ~ 2027/01/09 週期），該筆點數將於 2028/12/31 正式失效。")])])], 1)])])], 1) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "發送推播"
    }
  }), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goListPage
    }
  }, [_vm._v("返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1)], 1) : _vm._e()])], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }